const FAVOURITE_PRODUCTS_KEY = 'rb_favourite_products';

/* Keyed by card id + swatch. Not product.Code - one Code covers several tiles that differ
   by side stones. Image urls are rebuilt at render time, not stored. */
export interface FavouriteEntry {
  id: string;
  color?: string;
  product: any;
}

/* Also used as a DOM id, so keep it a valid CSS identifier. */
export const favouriteKey = (id?: string, color?: string) => `${id}-${color}`;

const entryKey = (entry: FavouriteEntry) => favouriteKey(entry.id, entry.color);

const write = (entries: FavouriteEntry[]): FavouriteEntry[] => {
  try {
    localStorage.setItem(FAVOURITE_PRODUCTS_KEY, JSON.stringify(entries));
  } catch (error) {
    console.error(error)
  }
  return entries;
};

export const readFavouriteEntries = (): FavouriteEntry[] => {
  try {
    const stored = JSON.parse(localStorage.getItem(FAVOURITE_PRODUCTS_KEY) || '[]');
    if (!Array.isArray(stored)) return [];
    const seen = new Set<string>();
    return stored.reduce((entries: FavouriteEntry[], entry: any) => {
      /* No product means no card to render. */
      if (!entry?.product) return entries;
      /* Pre-card-id entries cannot be told apart. */
      if (typeof entry.id !== 'string') return entries;
      const color = entry.color || entry.product.default_options?.Color;
      const next = { id: entry.id, color, product: entry.product };
      if (seen.has(entryKey(next))) return entries;
      seen.add(entryKey(next));
      entries.push(next);
      return entries;
    }, []);
  } catch (error) {
    return [];
  }
};

export const toggleFavouriteProduct = (entry: FavouriteEntry): FavouriteEntry[] => {
  const current = readFavouriteEntries();
  const key = entryKey(entry);
  return write(
    current.some((saved) => entryKey(saved) === key)
      ? current.filter((saved) => entryKey(saved) !== key)
      : [ ...current, entry ]
  );
};

